import Vue from 'vue'
import store from '@/store'
import i18n from '@/i18n/locale'
// 引入必要的组件
import '@/utils/common/go' // 确保go组件被注册

let vueInstance = null

export function initVue(config = {}) {
  // 创建一个完整配置的Vue实例
  vueInstance = new Vue({
    store,
    i18n,
    render: h => h('div'), // 使用render函数而不是template
    ...config,
  })
  return vueInstance
}

export function getVueInstance() {
  if (!vueInstance) {
    // 如果没有初始化，自动初始化一个基础实例
    console.log('Vue instance not found, creating a new one...')
    try {
      vueInstance = new Vue({
        store,
        i18n,
        render: h => h('div'),
      })
    } catch (error) {
      console.error('Failed to create Vue instance:', error)
      return null
    }
  }
  return vueInstance
}
